<template>
  <footer
    v-if="showFooter"
    class="bottom-0 flex w-full flex-col items-center px-4"
  >
    <hr class="w-full" />
    <div
      class="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 pb-2 pt-3 text-min"
    >
      <UIExternalLink
        v-if="imprintUrl"
        :to="imprintUrl"
        class="link no-underline hover:underline"
      >
        {{ $t('footer.imprint') }}
      </UIExternalLink>
      <span
        v-if="imprintUrl && (privacyPolicyUrl || showPrivacySettingsLink)"
        aria-hidden="true"
      >
        •
      </span>
      <UIExternalLink
        v-if="privacyPolicyUrl"
        :to="privacyPolicyUrl"
        class="link no-underline hover:underline"
      >
        {{ $t('footer.privacyPolicy') }}
      </UIExternalLink>
      <span
        v-if="privacyPolicyUrl && showPrivacySettingsLink"
        aria-hidden="true"
      >
        •
      </span>
      <button
        v-if="showPrivacySettingsLink"
        type="button"
        class="text-inherit link cursor-pointer border-0 bg-transparent p-0 no-underline [font:inherit] hover:underline"
        data-test-id="privacy-settings-button"
        @click="showSettings"
      >
        {{ $t('consent.privacySettings.linkText') }}
      </button>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { useCookieConsent } from '@booking-portal/modules/cookie/composables/use-cookie-consent';
import UIExternalLink from '@booking-portal/modules/ui/components/UIExternalLink.vue';
import { useAppStore } from '@booking-portal/stores/app-store';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const appStore = useAppStore();
const { showSettings } = useCookieConsent();

// TODO: Refactor this because this is not a good way to check if we are in the customer portal & could break in the future
const isCustomerPortalRoute = computed(() =>
  route.fullPath?.includes('customer-portal')
);

const imprintUrl = computed(() =>
  isCustomerPortalRoute.value
    ? appStore.globalImprintUrl
    : appStore.locationImprintUrl
);

const privacyPolicyUrl = computed(() =>
  isCustomerPortalRoute.value
    ? appStore.globalPrivacyPolicyUrl
    : appStore.locationPrivacyPolicyUrl
);

// Only show the "change privacy settings" link when the built-in consent
// banner is actually enabled for this tenant. `CookieConsent.vue` is mounted
// in `App.vue` behind the same flag — without it, clicking the link would
// clear stored consent but no modal would open.
const showPrivacySettingsLink = computed(
  () => !!appStore.setupData?.showConsentBanner
);

const showFooter = computed(() => {
  if (showPrivacySettingsLink.value) {
    return true;
  }

  if (isCustomerPortalRoute.value) {
    return !!appStore.globalImprintUrl || !!appStore.globalPrivacyPolicyUrl;
  }

  return (
    !!appStore.locationImprintUrl ||
    !!appStore.locationPrivacyPolicyUrl ||
    !!appStore.globalImprintUrl ||
    !!appStore.globalPrivacyPolicyUrl
  );
});
</script>
